import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {CategorieDemat} from "../../components/form/models/formdemat.model";

@Injectable({
  providedIn: 'root'
})
export class CategorieService extends DaoGeneric<CategorieDemat> {
  private url = `${environment.baseUrl}/demat/categories/`;
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }
}
